<template>
    <div>
       <div class="banner"><img :src="require('@/assets/img/about/introduction/banner.png')" alt="" style="width: 100%" data-aos="zoom-out"></div>
       <div class="container">
            <about-menu @aboutSelect="aboutSelect"></about-menu>
            <div>
               <div class="introduction">
                    <div class="title" >上海唐颐信息技术有限公司</div>
                    <div class="border" data-aos="fade-up"></div>
                    <div class="pic" data-aos="flip-up"><img :src="require('@/assets/img/about/introduction/introduction.png')" alt=""></div>
                    <div class="content">
                        <div data-aos="fade-up">上海唐颐信息技术有限公司是一家专注于生物医学大数据和精准医疗信息技术产品与服务的高科技企业，致力于成为生物医学大数据整合分析领域的专业技术服务商。依托核心团队十余年技术积累，公司精心打造了临床三库（样本库、数据库、知识库）、AI 医疗智能体、智能医学科研数据中心、智慧科研数据资产管理平台等解决方案。核心产品包含：临床数据与样本资源库管理系统、细胞全生命周期信息管理系统、智能专病数据库管理平台、科研项目管理平台、医学实验室管理平台、罕见病与知识库检索分析系统、精准医学知识库管理平台、医学科研数据中心、智能 AI 辅助审核智能体、医学专业智能体服务平台等。
                        </div>
<!--                        <div data-aos="fade-up">唐颐信息首席科学顾问刘雷教授，现任复旦大学智能医学研究院常务副院长、国际健康科学信息学研究院（IAHSI）院士。依托复旦大学智能医学研究院的专家团队，公司汇聚了生物信息学、大数据、人工智能、软件工程学等多领域的人才，在生物医学数据采集、集成与分析等方面具有丰富经验，所研发的产品支持多种数据类型，如生物样本数据、生信数据、医学影像数据、专病数据等，并实现系统整合与挖掘分析，建立精准医学大数据共享服务体系。这不仅能服务临床科研，还可推动分子诊断、精准用药与生物细胞治疗等的临床转化。</div>-->
<!--                        <div data-aos="fade-up">公司产品已在逾300家三甲医院、高校、研究机构与企业落地，代表客户包括中国人民解放军总医院、复旦大学(附属17家医院，16个二级学院及研究院)、中山大学(附属3家医院)、天津医科大学（附属5家医院)、河北医科大学（附属5家医院）、南方医科大学南方医院、东方肝胆外科医院、中国食品药品检定研究院、上海生物样本库、武汉协和医院、广州金域医学检验集团等。</div>-->
                        <div data-aos="fade-up">公司首席科学顾问刘雷教授，现任复旦大学智能医学研究院常务副院长、国际健康科学信息学研究院（IAHSI）院士，曾主持及参与多项国家重点研发计划，担任国家 “十三五” 精准医学重点研发计划项目首席专家；深耕生物医学大数据、智能医学与生物信息学研究，多项成果刊载于生物信息学、医学信息学领域权威期刊。
                        </div>
                      <div data-aos="fade-up">公司与复旦大学智能医学研究院开展学术合作，汇聚生物信息学、分子生物学、临床医学、软件工程、大数据、人工智能等跨领域专业人才，在生物医学大数据采集、集成与分析方面具备丰富实践经验。公司相关产品可支撑生物样本数据、生信数据、医学影像数据、专病数据等多类医学数据，实现系统集成与数据挖掘分析，构建精准医学大数据共享服务体系，服务临床科研工作，助力分子诊断、精准用药、生物细胞治疗方向的临床转化研究。
                      </div>
                    </div>
               </div>
               <!-- 公司历程 -->
                <div  class="history">
                  <div class="historyTitle"  data-aos="fade-up">公司历程</div>
                  <div class="historyContent">
                    <div class="historyText">
                      <div data-aos="fade-right" style="width: 180px;padding-left: 120px;">
                        唐颐信息子公司无锡众信科技有限公司成立，与我国十家大型三甲医院开展合作，包括301医院、武汉协和医院、中山大学附属第一医院等。
                      </div>
                      <div data-aos="fade-right" style="width: 240px;padding-left: 130px;padding-top: 10px;">
                        唐颐信息与上海市东方医院合作开发了“干细胞临床研究信息化管理平台”;公司参与“十三五”国家重点研发计划。
                      </div>
                      <div data-aos="fade-left" style="width: 184px;padding-left: 116px;padding-top: 75px;">
                        刘雷教授当选国际健康科学信息学研究院(IAHSI)院士；唐颐信息入选“中国干细胞产业联盟”理事单位。
                      </div>
                      <div data-aos="fade-left" style="width: 200px;padding-left: 136px;padding-top: 113px;">
                        《干细胞临床研究信息管理规范》团体标准在全国团体标准信息平台公布实施，唐颐信息作为起草单位参与标准制定。
                      </div>
                    </div>
                    <img :src="require('@/assets/img/home/history1.png')" alt="" width="1329" style="margin: 52px 0;" data-aos="flip-up">
                    <div class="historyText">
                      <div data-aos="fade-right"  style="width: 173px;padding-left: 15px;">
                        公司首席科学顾问刘雷教授入选“中国科学院百人计划”，同年承担国家863与上海市重大专项。
                      </div>
                      <div data-aos="fade-right" data-wow-duration="2s" style="width: 150px;padding-left: 122px;">
                        刘雷教授作为项目首席，承担国家重点研发计划“精准医学研究”重点专项：疾病研究精准医学知识库构建（项目编号：2016YFC0901900）
                      </div>
                      <div data-aos="fade-left" style="width: 160px;padding-left: 136px;">
                        唐颐信息入选中国研究型医院学会临床数据与样本资源库专业委员会委员单位；刘雷教授与公司CEO唐万,分别当选专委会副主任委员、信息组学秘书长。
                      </div>
                      <div data-aos="fade-left" style="width: 160px;padding-left: 230px;">
                        唐颐信息入驻“数字健康新质生产力服务平台”，成为首批入驻的数字健康领域供给侧企业。
                      </div>
                    </div>
                  </div>
                </div>
               <!-- 公司资质 -->
               <div class="qualification">
                  <div class="qualificationTitle" data-aos="fade-up">公司资质</div>
                  <div class="qualificationContent">
                    <div class="title" data-aos="fade-up">荣获国家版权局“计算机软件著作权”</div>
                    <div class="copyrightList">
                        <div v-for="item in copyrightList" data-aos="fade-up">
                            <img :src="require('@/assets/img/about/introduction/copyright.png')" alt="" style="margin-right: 5px"> {{item}}
                        </div>
                    </div>
                    <div class="pass" data-aos="fade-left">......</div>
                  </div>
                  <div class="qualificationList">
                        <div class="line">
                            <div data-aos="fade-right"><div>唐颐生物资源<br>运输监控平台</div></div>
                            <div data-aos="fade-right"></div>
                            <div data-aos="fade-left"><div>唐颐临床数据<br>与样本管理系统<br>V6.1</div></div>
                            <div data-aos="fade-left"><div>多中心生物资源<br>信息共享平台</div></div>
                        </div>
                        <div class="line">
                            <div data-aos="fade-right"><div>CTMS临床试验项目<br>管理系统</div></div>
                            <div data-aos="flip-up"></div>
                            <div data-aos="fade-left"></div>
                        </div>
                        <div class="line">
                            <div data-aos="fade-right"></div>
                            <div data-aos="fade-left"><div style="padding: 80px 0;box-sizing: border-box">全息专病数据库<br>管理平台</div></div>
                        </div>
                  </div>
                  <div class="qualificationSwiper">
                    <div class="prev" data-aos="fade-right">
                      <i class="el-icon-arrow-left"></i>
                    </div>
                    <swiper :options="swiperOption" ref="mySwiper" data-aos="zoom-in">
                        <swiper-slide v-for="item,index in qualificationList" :key="'qualification'+index" >
                            <img :src="item.src" alt="" style="width: 100%;">
                        </swiper-slide>
                    </swiper>
                    <div class="next" data-aos="fade-left">
                      <i class="el-icon-arrow-right"></i>
                    </div>
                  </div>
               </div>
            </div>
        </div>
    </div>
</template>

<script>
import WOW from '../../../node_modules/wowjs/dist/wow';
import AboutMenu from "../../components/AboutMenu";
export default {
    components: {
	    AboutMenu
    },
    data(){
      return {
          qualificationList:[
            {src:require('@/assets/img/soft/rz(1).jpeg')},
            {src:require('@/assets/img/soft/rz(1).jpg')},
            {src:require('@/assets/img/soft/rz(1).png')},
            {src:require('@/assets/img/soft/rz(2).jpeg')},
            {src:require('@/assets/img/soft/rz(2).jpg')},
            {src:require('@/assets/img/soft/rz(2).png')},
            {src:require('@/assets/img/soft/rz(3).jpeg')},
            {src:require('@/assets/img/soft/rz(3).jpg')},
            {src:require('@/assets/img/soft/rz(3).png')},
            {src:require('@/assets/img/soft/rz(4).jpeg')},
            {src:require('@/assets/img/soft/rz(4).jpg')},
            {src:require('@/assets/img/soft/rz(5).jpeg')},
            {src:require('@/assets/img/soft/rz(5).jpg')},
            {src:require('@/assets/img/soft/rz(6).jpg')},
            {src:require('@/assets/img/soft/rz(7).jpg')},
            {src:require('@/assets/img/soft/rz(8).jpg')},
            {src:require('@/assets/img/soft/rz(9).jpg')},
            {src:require('@/assets/img/soft/rz(10).jpg')},
            {src:require('@/assets/img/soft/rz(11).png')},
            {src:require('@/assets/img/soft/rz(12).jpg')},
          ],
          swiperOption:{
              navigation: {
                nextEl: ".next",
                prevEl: ".prev",
              },
              slidesPerView: 5,
              autoplay: {
                delay: 2000,
                disableOnInteraction: false,
              },
              direction: "horizontal",
              loop: true,
              centeredSlides: true,
              spaceBetween: 20,
              observer: true,
              observeParents: true,
          },
          copyrightList:[
              '唐颐临床研究伦理管理系统','唐颐科研大数据AI分析平台','EDC临床试验管理系统',
              '唐颐临床研究随访管理系统','肺结节图像过滤软件系统','唐颐细胞生命周期信息管理系统',
              '唐颐临床研究项目管理系统','肺癌智能辅助诊断软件系统','大数据3D建模智能管理平台',
              '唐颐精准医学大数据平台','肺癌影像学导航学习软件系统','唐颐组学数据整合管理系统'
          ]
      }
    },
    mounted() {
        let wow = new WOW.WOW({
            boxClass: 'wow',
            animateClass: 'animated',
            offset: 0,
            mobile: true,
            live: true
        });
        wow.init();
    },
    methods:{
        aboutSelect(src){
	        this.$emit('aboutSelect',src)
        }
    }
}
</script>

<style lang="less" scoped>
    .container{
        width: 100%;
        padding-left: 20%;
        box-sizing: border-box;
        position: relative;
    }
    .introduction{
        width: 100%;
        overflow: hidden;
        .title{
            margin: 90px 0 45px 0;
            text-align: center;
            font-size: 12px;
            letter-spacing: 2px;
            color: #282828;
            font-family: "YRDZST";
            -moz-transform: matrix( 2.66354962436808, 0, 0, 2.66354962436808, 0, 0);
            -webkit-transform: matrix( 2.66354962436808, 0, 0, 2.66354962436808, 0, 0);
            font-weight: bold;
        }
        .border{
            width: 62px;
            height: 5px;
            margin: 0 auto;
            background: #ed1c24;
        }
        .pic{
            width: 1076px;
            margin: 52px auto 70px;
        }
        .content{
            width: 1076px;
            margin: 0 auto;
            div{
                font-size: 14px;
                letter-spacing: 0.6px;
                line-height: 32px;
                text-indent: 2em;
            }
        }
    }
    .history{
        width: 100%;
        margin-top: 100px;
        padding-top: 90px;
        background: #fafdff;
        .historyTitle{
          width: 100%;
          height: 63px;
          line-height: 40px;
          margin-bottom: 110px;
          color: #ed1c24;
          text-align: center;
          font-size: 33px;
          background: url(../../assets/img/about/introduction/historyTitle.png) center no-repeat;
          letter-spacing: 12px;
        }
        .historyContent{
          width: 100%;
          text-align: center;
          .historyText{
            width: 1329px;
            display: flex;
            margin: 0 auto;
            text-align: left;
            font-size: 14.5px;
            letter-spacing: 1px;
          }
        }
    }
    .qualification{
        width: 100%;
        margin-top: 134px;
        padding-top: 160px;
        background: url("../../assets/img/about/introduction/qualificationBg.png") no-repeat;
        .qualificationTitle{
          height: 61px;
          padding-left: 16px;
          box-sizing: border-box;
          line-height: 25px;
          margin-bottom: 104px;
          color: #ed1c24;
          text-align: center;
          font-size: 33px;
          letter-spacing: 12px;
          background:url(../../assets/img/about/introduction/qualificationTitle.png) center no-repeat;
        }
        .qualificationContent{
            margin-bottom: 206px;
            .title{
                font-size: 33px;
                text-align: center;
                letter-spacing: 3px;
            }
            .copyrightList{
                width: 902px;
                display: flex;
                flex-wrap: wrap;
                margin: 76px auto 0;
                div{
                    width: 33.3%;
                    height: 18px;
                    margin-bottom: 27px;
                    font-size: 18px;
                    letter-spacing: 1px;
                    img{
                        vertical-align: middle;
                    }
                }
            }
            .pass{
                width: 800px;
                margin: 0 auto;
                text-align: right;
                font-size: 18px;
                letter-spacing: 1px;
            }
        }
        .qualificationList{
            width: 1156px;
            margin: 0 auto;
            .line{
                width: 100%;
                display: flex;
                justify-content: space-between;
                &>div{
                    width: 270px;
                    height: 270px;
                    position: relative;
                    color: #fff;
                    background-size: 100% 100%;
                    line-height: 30px;
                    cursor: pointer;
                    &>div{
                        width: 100%;
                        height: 100%;
                        background: url("../../assets/img/about/introduction/qualificationListBg.png") no-repeat;
                        color: #fff;
                        align-items: center;
                        justify-content: center;
                        letter-spacing: 2px;
                        flex-wrap: wrap;
                        text-align: center;
                        display: flex;
                        div:nth-child(2){
                            width: 100%;
                            font-size: 14px;
                            color: #fff;
                        }
                    }
                }
                &>div:hover{
                    &>div{
                        display: flex;
                    }
                }
                &>div:nth-child(1){
                    background: url("../../assets/img/about/introduction/qualificationList1.png");
                }
                &>div:nth-child(2){
                    background: url("../../assets/img/about/introduction/qualificationList2.png");
                }
                &>div:nth-child(3){
                    background: url("../../assets/img/about/introduction/qualificationList3.png");
                }
                &>div:nth-child(4){
                    background: url("../../assets/img/about/introduction/qualificationList4.png");
                }
            }
            .line:nth-child(3){
                width: 564px;
                margin: 0 auto;
            }
            .line:nth-child(3){
                &>div:nth-child(1){
                    background: url("../../assets/img/about/introduction/qualificationList5.png");
                }
                &>div:nth-child(2){
                    background: url("../../assets/img/about/introduction/qualificationList6.png");
                }
            }
            .line:nth-child(2){
                width: 860px;
                margin: -120px auto;
            }
            .line:nth-child(2){
                &>div:nth-child(1){
                    background: url("../../assets/img/about/introduction/qualificationList7.png");
                }
                &>div:nth-child(2){
                    background: url("../../assets/img/about/introduction/qualificationList9.png");
                }
                &>div:nth-child(3){
                    background: url("../../assets/img/about/introduction/qualificationList8.png");
                }
            }

        }
        .qualificationSwiper{
          display: flex;
          width: 1200px;
          margin: 150px auto;
          align-items: center;
          .prev{
            width: 50px;
            height: 90px;
            background: #ed1d25;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            i{
              color: #fff;
              font-size: 40px;
            }
          }
          .next{
            width: 50px;
            height: 90px;
            background: #ed1d25;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            i{
              color: #fff;
              font-size: 40px;
            }
          }
          .swiper-container{
            width: 1060px;
            margin: 0 auto;
            .swiper-slide {
              display: flex;
              flex-wrap: wrap;
              text-align: center;
              font-size: 18px;
              background: #fff;
              width: 100%;
              height: 100%;
              /* Center slide text vertically */
              display: -webkit-box;
              display: -ms-flexbox;
              display: -webkit-flex;
              display: flex;
              -webkit-box-pack: center;
              -ms-flex-pack: center;
              -webkit-justify-content: center;
              justify-content: center;
              -webkit-box-align: center;
              -ms-flex-align: center;
              -webkit-align-items: center;
              align-items: center;
              transition: 300ms;
              transform: scale(0.8);
            }

            .swiper-slide-active,
            .swiper-slide-duplicate-active {
              transform: scale(1);
            }
          }
        }
    }
</style>
